'use client';

import { GlobeHemisphereWest, Lock } from 'phosphor-icons';
import { pluralize } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Avatar } from '../../atoms/Avatar';
import type { ProductListInfoProps } from './ProductListInfo.types';

export const ProductListInfo = ({
  className = '',
  count,
  visibility,
  userName,
  hideUserAvatar = false,
  microcopy,
}: ProductListInfoProps) => {
  const assetsText = pluralize(
    'assetsLabel',
    {
      assetsLabelOne: microcopy.assetsLabelOne,
      assetsLabelOther: microcopy.assetsLabelOther,
    },
    count
  );
  const visibilityLabel =
    visibility === 'private' ? microcopy.privateLabel : microcopy.publicLabel;
  const VisibilityIcon = visibility === 'private' ? Lock : GlobeHemisphereWest;

  return (
    <div className={c('flex flex-col gap-2', className)}>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-0">
        <span className="body-small text-content-muted">{assetsText}</span>
        <span className="text-content-muted">•</span>
        <div className="flex items-center gap-1 text-content-muted">
          <VisibilityIcon size={16} weight="fill" aria-hidden="true" />
          <span className="body-small">{visibilityLabel}</span>
        </div>
      </div>
      {userName && !hideUserAvatar && (
        <div className="flex items-center gap-2">
          <Avatar
            userName={userName}
            size={24}
            className="shrink-0"
            textClassName="text-white text-[10px]"
          />
          <span className="body-small text-content-muted">{userName}</span>
        </div>
      )}
    </div>
  );
};

ProductListInfo.displayName = 'ProductListInfo';
